export const siteName = 'Pharlog Cloud'
export const year = 2022
